module.exports = __webpack_public_path__ + "static/media/clas.cdb4a8e4.jpg";